var React = require('react');

function ArrowThinLeft (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow-thin-left"),React.createElement("path",{"d":"M39.6,88.8a1,1,0,0,1-.7-.3L.3,45.1a1,1,0,0,1,0-1.3L38.9.3a1,1,0,1,1,1.5,1.3L2.3,44.4l38,42.7a1,1,0,0,1-.1,1.4Z","fill":"currentColor","key":1})]);
}

ArrowThinLeft.defaultProps = {"width":"40.6","height":"88.8","viewBox":"0 0 40.6 88.8"};

module.exports = ArrowThinLeft;

ArrowThinLeft.default = ArrowThinLeft;
